import React from 'react';
export const FacialCare: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.607"
      height="18"
      fill="currentColor"
      {...props}
    >
      <g data-name="Facial Care" fill="currentColor">
        <path
          data-name="Path 21767"
          d="M3.857 0a5.107 5.107 0 00-3.76 1.657.373.373 0 00-.043.446l2.124 3.472V16.32a1.679 1.679 0 003.357 0V5.575l2.124-3.472a.373.373 0 00-.043-.446A5.107 5.107 0 003.857 0zm.933 8.7H2.925V5.839H4.79zm0 7.616a.933.933 0 11-1.865 0v-6.87H4.79zm.164-11.224H2.76L.842 1.956a4.346 4.346 0 016.03 0z"
        />
        <path
          data-name="Path 21768"
          d="M12.707 2.394A4.158 4.158 0 0011.048.071a.372.372 0 00-.42 0 4.158 4.158 0 00-1.659 2.323 2.217 2.217 0 00.377 1.653v12.46a1.492 1.492 0 002.984 0V4.047a2.216 2.216 0 00.377-1.653zm-2.616 1.909h1.492v2.346h-1.491zm-.388-1.781a1.221 1.221 0 112.269 0 1.454 1.454 0 01-.214 1.035H9.916a1.453 1.453 0 01-.214-1.035zm1.881 13.985a.746.746 0 11-1.492 0V7.394h1.492z"
        />
        <path
          data-name="Path 21769"
          d="M20.352.515a9.923 9.923 0 00-6.27 0 .373.373 0 00-.24.459l1.14 3.874.744 11.685a1.492 1.492 0 002.983 0l.743-11.683 1.14-3.874a.373.373 0 00-.24-.461zm-1.828 7.17H15.91l-.161-2.529h2.935zm-.56 8.8a.747.747 0 11-1.494 0l-.512-8.053h2.518zm.839-12.072h-3.172l-.969-3.295a9.187 9.187 0 015.111 0z"
        />
      </g>
    </svg>
  );
};
